module.exports = __webpack_public_path__ + "static/media/bottle_2.fac4b62e.png";